export default __webpack_public_path__ + "static/media/tab-content-image-01.2c166654.jpg";